import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/coupons")({
	component: CouponsLayout,
})

function CouponsLayout() {
	return <Outlet />
}
